import { defineMessages } from 'react-intl';
import { connect } from 'react-redux';
import Global from '../../../store/global-selectors';
import { AddNote } from '../bulk-update-actions/add-note';
import { AddTaxIdentifiers } from '../bulk-update-actions/add-tax-identifiers';
import { CustomField1 } from '../bulk-update-actions/custom-field-1';
import { CustomField2 } from '../bulk-update-actions/custom-field-2';
import { CustomField3 } from '../bulk-update-actions/custom-field-3';
import { CustomsDeclarations } from '../bulk-update-actions/customs-declarations';
import { ApplyShippingPreset } from '../bulk-update-actions/apply-shipping-preset';
import { OtherShippingOptions } from '../bulk-update-actions/other-shipping-options';
import { AdjustWeight } from '../bulk-update-actions/adjust-weight';
import { Insurance } from '../bulk-update-actions/insurance';
import { Service } from '../bulk-update-actions/service';
import { ShippingAccount } from '../bulk-update-actions/shipping-account';
import { ShipFrom } from '../bulk-update-actions/ship-from';
import { PackageBulkAction } from '../bulk-update-actions/package-bulk-action';
import { ShipByDate } from '../bulk-update-actions/ship-by-date';
import { PackingSlipTemplate } from '../bulk-update-actions/packing-slip-template';
import { Confirmation } from '../bulk-update-actions/confirmation';
import { DoNotNotifyMarketplace } from '../bulk-update-actions/do-not-notify-marketplace';
import { Size } from '../bulk-update-actions/size';
import { EmailTemplate } from '../bulk-update-actions/email-template';
import { DutiesAndTaxes } from '../bulk-update-actions/duties-and-taxes';
import { getActualFulfillmentPlanIds } from '../../../store/orders/orders.helpers';

import { BaseOrdersBulkUpdateMenuItemsContainer } from '../base-bulk-update-menu-container/base-orders-bulk-update-menu-items-container';

const messages = defineMessages({
  order: {
    description: 'orderBulkActions.order',
    defaultMessage: 'Order',
    id: 'TptMwh',
  },
  shipment: {
    description: 'orderBulkActions.shipment',
    defaultMessage: 'Shipment',
    id: '3ueTsd',
  },
});

const orderSection = {
  sectionName: messages.order,
  actions: [ShipByDate],
};

const shipmentSection = {
  sectionName: messages.shipment,
  actions: [
    AddNote,
    ApplyShippingPreset,
    CustomField1,
    CustomField2,
    CustomField3,
    Service,
    ShippingAccount,
    PackageBulkAction,
    AdjustWeight,
    Size,
    ShipFrom,
    Insurance,
    Confirmation,
    DoNotNotifyMarketplace,
    EmailTemplate,
    PackingSlipTemplate,
    OtherShippingOptions,
    CustomsDeclarations,
    AddTaxIdentifiers,
  ],
};

export const actionSections = [orderSection, shipmentSection];

const mapStateToProps = (state) => {
  if (!shipmentSection.actions.includes(DutiesAndTaxes)) {
    shipmentSection.actions.push(DutiesAndTaxes);
  }

  return {
    idsSelector: () => {
      const salesOrderIds = Global.selectSelectedOrdersIds(state);
      const actualFulfillmentPlanIds = getActualFulfillmentPlanIds(state, salesOrderIds);

      return actualFulfillmentPlanIds;
    },
    actionSections,
    dataTypeKey: 'fulfillmentPlan',
  };
};

export const OrdersGridBulkUpdateMenuContainer = connect(mapStateToProps)(BaseOrdersBulkUpdateMenuItemsContainer);
